import React, { Component } from 'react'
import FirstViewlist from '../firstviewlist'
import * as styles from './firstview.module.css'

export default class FirstView extends Component {

  render() {
    return (
      <div className={styles.firstview}>
        <p className={styles.firstview_h2}>おすすめ記事 ＆ ピックアップ記事</p>
        <div className={styles.firstview_contents}>
          {/* １列目 */}
          <FirstViewlist target={'titifuckactress'} />
          <FirstViewlist target={'titifuckbest'} />
          <FirstViewlist target={'pzyear'} />
          <FirstViewlist target={'debut'} />
          {/* ２列目 */}
          <FirstViewlist target={'titifuckfacial'} />
          <FirstViewlist target={'titifuckseries'} />
          <FirstViewlist target={'titifuckvr'} />
          <FirstViewlist target={'cospa'} />
          {/* ３列目 */}
          <FirstViewlist target={'fuzoku'} />
          <FirstViewlist target={'mgs'} />
          <FirstViewlist target={'duga'} />
          {/* 2025年6月8日 23:59 */}
          <FirstViewlist target={'smok00007'} />
          {/* ４列目 */}
          {/* 2025年6月10日 23:59 */}
          <FirstViewlist target={'60rbmx00021'} />
          {/* 2025年6月9日 09:59 */}
          <FirstViewlist target={'ipx00281'} />
          <FirstViewlist target={'ssis00950'} />
          {/* 2025年6月8日 11:59 */}
          <FirstViewlist target={'ofje00558'} />
        </div>
      </div>
    )
  }
}